export default "__VITE_ASSET__091f23ec__"